<template>
    <div class="modal-card">
        <section class="modal-card-body">
            <login-logo></login-logo>
            <h3 class="title has-text-centered has-text-dark">Member Login</h3>
            <div class="box">
                    <b-field label="E-Mail">
                        <b-input v-model="username" type="email" placeholder="Modal E-Mail">
                        </b-input>
                    </b-field>

                    <b-field label="Password">
                        <b-input v-model="password" type="password" placeholder="Modal Password" minlength="6" password-reveal>
                        </b-input>
                    </b-field>
                    <b-field>
						<a class="password-remind-link has-text-dark is-pulled-right" @click="passwordReminder()">I forgot my password</a>
                    </b-field>
                    <button class="button is-dark is-large is-fullwidth" @click="doLogin()">
                        Login
                    </button>
                </div>
				<div class="has-text-centered">
					<router-link v-on:click.native="closeModal()" to="/register">Signup!</router-link>
				</div>
        </section>
    </div>
</template>

<script>
import LoginLogo from "../features/LoginLogo"
import PasswordForgot from "./PasswordForgot"

export default {
  name: 'LoginModal',
  data () {
    return {
      username: '',
      password: '',
    }
  },
  components: {
    LoginLogo,
    PasswordForgot
  },
  methods: {
    passwordReminder() {
        this.$parent.close()
		this.$modal.open({
			parent: this,
			component: PasswordForgot,
			hasModalCArd: true,
			props: {
			}
		})
    },
    closeModal() {
        this.$parent.close()
	},
	doLogin() {
		this.$parent.close()
		this.$router.push('/dashboard')
	}
  }
}
</script>

<style scoped>
.password-remind-link {
	margin-bottom: 10px;
}
.background-light {
	background-color: hsl(0, 0%, 96%);
}
</style>



// WEBPACK FOOTER //
// src/components/modals/LoginModal.vue